import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useGetReferralEarningsQuery } from '@api/queries/user';

import { checkIfClaimDateIsToday } from '@/common/lib/checkIfClaimDateIsToday';
import { EarnCashAndCoin } from '@/components/Partners/EarnCashAndCoin/EarnCashAndCoin';
import { EarnTonSection } from '@/components/Partners/EarnTonSection/EarnTonSection';
import { HeroImage } from '@/components/Partners/HeroImage/HeroImage';
import { Invite } from '@/components/Partners/Invite/Invite';
import { PartnersFaq } from '@/components/Partners/PartnersFaq/PartnersFaq';
import { PartnersMainInfo } from '@/components/Partners/PartnersMainInfo/PartnersMainInfo';

const Partners: React.FC = () => {
  useGetReferralEarningsQuery();

  useEffect(() => {
    const holdedBalanceIsVisitToday = checkIfClaimDateIsToday(
      'claim-holded-balance',
    );

    if (!holdedBalanceIsVisitToday) {
      localStorage.setItem('claim-holded-balance', new Date().toISOString());
    }
  }, []);

  return (
    <main className="h-full flex flex-col">
      <div className="flex-1 relative hidden-scrollbar overflow-y-auto">
        <Helmet>
          <title>Partners</title>
        </Helmet>
        <HeroImage />
        <PartnersMainInfo />
        <EarnTonSection />
        <EarnCashAndCoin />
        <PartnersFaq />
      </div>
      <Invite className="bg-[#181A20]" />
    </main>
  );
};

export default Partners;
